import React from 'react';

import {
  Route,
} from 'react-router-dom'
import InvalidAccess from './InvalidAccess';

const AdminRoute = ({ component: Component, isAuthenticated, isAdmin, ...rest }) => (
  <Route
    {...rest}
    render={props => (
        isAuthenticated && isAdmin
        ? <Component {...props} />
        : <InvalidAccess to="/login" />
    )}
  />
);

export default AdminRoute;



// WEBPACK FOOTER //
// ./src/components/Auth/AdminRoute.js